const emptyFunction: () => void = () => {
	// Do nothings
};
const returnEmptyFunction: () => () => void = () => emptyFunction;

/**
 * Latch.
 */
export default class Latch {
	public isFirstRun = true;
	public isFinished = false;
	private list: Array<() => void> = [];

	/**
	 * Takes a lock, causing execution to wait if number of callers exceeds maxCount.
	 *
	 * @returns Promise resolved or not depending on if caller must wait.
	 */
	public aquire(): Promise<() => void> {
		if (this.isFinished) {
			return Promise.resolve(returnEmptyFunction);
		} else if (this.isFirstRun) {
			this.isFirstRun = false;
			return Promise.resolve().then(this.getFirstReleaseFunction.bind(this));
		} else {
			return new Promise(this.addResolveToList.bind(this)).then(returnEmptyFunction);
		}
	}

	/**
	 * Add promise resolve to list.
	 *
	 * @param resolve Argument from Promise constructor.
	 */
	private addResolveToList(resolve: () => void): void {
		this.list.push(resolve);
	}

	/**
	 * @returns A function for release.
	 */
	private getFirstReleaseFunction(): () => void {
		return (): void => this.firstRelease();
	}

	/**
	 * First release.
	 */
	private firstRelease(): void {
		this.isFinished = true;
		this.releaseAll();
	}

	/**
	 * Release all promises.
	 */
	private releaseAll(): void {
		this.list.forEach((fun) => fun());
		this.list = [];
	}
}
